define([
    "jquery",
    "underscore",
    "marionette",
    "behaviors/form_errors_behavior",
    "jquery.fileupload",
    "holdon"
], function($, _, Marionette, FormErrorsBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        ui:{
            'uploadAvatarFile': '#upload_avatar_file',
            'avatar': '#avatar',
            'removeAvatar': '#remove_avatar'
        },

        events:{

        },

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            }
        },

        initialize: function(){
            this.bindUIElements();

            this.initFileUpload(this.ui.uploadAvatarFile);
        },

        initFileUpload: function($selector){
            var that = this;
            $selector.fileupload({
                url: '/rest_profile/avatar',
                dataType: 'json',
                dropZone: that.ui.avatar,
                add: function(e, data){
                    HoldOn.open({
                        theme:"sk-fading-circle"
                    });
                    data.submit();
                },
                done: function(e, data){
                    that.ui.avatar.attr('src','/common/show_avatar?file='+data.jqXHR.responseJSON.file_path);

                    HoldOn.close();
                },
                fail: function(e, data){
                    HoldOn.close();
                }
            });
        }
    });
});
